import { useHousehold } from './useHousehold'
import { DESKTOP_QUERY, useMediaQuery } from './useMediaQuery'
import {
  formatCurrency,
  formatCurrencyCompact,
  formatCurrencyWhole,
  formatCurrencyNoZeroPaise,
  currencySymbol,
  type CurrencyCode,
} from '@/lib/format'

export function useFormatCurrency() {
  const { data: household } = useHousehold()
  const currency: CurrencyCode = household?.currency ?? 'INR'

  return {
    format: (amount: number) => formatCurrency(amount, currency),
    formatCompact: (amount: number) => formatCurrencyCompact(amount, currency),
    formatWhole: (amount: number) => formatCurrencyWhole(amount, currency),
    formatNoZeroPaise: (amount: number) => formatCurrencyNoZeroPaise(amount, currency),
    symbol: currencySymbol(currency),
    currency,
  }
}

// Long lists of amounts on a phone: a zero paise is noise, real paise still show.
export function useListAmountFormat(): (amount: number) => string {
  const { format, formatNoZeroPaise } = useFormatCurrency()
  return useMediaQuery(DESKTOP_QUERY) ? format : formatNoZeroPaise
}
